import { h, Component } from 'preact';
import { addPixelImage } from '../../helper';
import style from './style';

function Slide(props) {
  const { item } = props;
  const title = (item && item.details && item.details.title) || '';
  const description = (item && item.details && item.details.description) || '';
  const cta = (item && item.details && item.details.cta) || '';
  const img =
    (item &&
      item.media &&
      item.media[0] &&
      (item.media[0].img1_360 || item.media[0].img1_src)) ||
    '';

  return (
    <div class={style.slide}>
      <div class={style.slideContent}>
        <div onClick={() => props.onItemClick(item)}>
          <div class={style.slideContent__image}>
            <img src={img} alt={title} />
          </div>
          <div class={`${style.slideContent__title} block-ellipsis`}>
            {description}
          </div>
          <div class={style.slideContent__description}>{title}</div>
        </div>
      </div>
    </div>
  );
}

export default class MagazineGallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      panels: [],
      touchStart: 0,
      touchEnd: 0,
      mouseDown: false,
    };
  }

  componentWillMount() {
    const WT_PLAY = document.getElementById('wtPlay');
    WT_PLAY.classList.add('magazine');
  }

  componentWillUnmount() {
    const WT_PLAY = document.getElementById('wtPlay');
    WT_PLAY.classList.remove('magazine');
  }

  componentDidMount() {
    this.setPanels(this.props.items);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.items && nextProps.items.length !== this.props.items.length) {
      this.setPanels(nextProps.items);
    }
  }

  setPanels = (items) => {
    const panels = [];
    items.forEach((item, idx) => {
      if (idx % 2 !== 0) return;
      const panel = { front: items[idx - 1], back: item, open: idx === 0, adjust: idx === 0 };
      panels.push(panel);
    });
    if (items.length % 2 === 0) {
      panels.push({ front: items[items.length - 1], back: null, open: false, adjust: false });
    }
    this.setState({ panels }, () => {
      this.fireImpressionTrackers([0, 1]); // fires proudct impression on load
    });
  };

  handleClick = (idx) => {
    clearTimeout(this.timeout);
    const panels = this.state.panels.map((panel, i) => {
      if (idx === i) {
        panel = { ...panel, open: !panel.open };
      }
      return panel;
    });
    this.setState({ panels }, () => {
      this.timeout = setTimeout(() => {
        const panels = this.state.panels.map((panel, i) => {
          if (idx === i) {
            panel = { ...panel, adjust: !panel.adjust };
          }
          return panel;
        });
        this.setState({ panels });
      }, 100);
    });
  };

  handleTouchStart = (e) => {
    this.setState({ touchStart: e.targetTouches[0].clientX });
  };

  handleTouchMove = (e) => {
    this.setState({ touchEnd: e.targetTouches[0].clientX });
  };

  handleMouseDown = (e) => {
    console.log(e)
    this.setState({ touchStart: e.clientX, mouseDown: true });
  };

  handleMouseMove = (e) => {
    if (this.state.mouseDown) {
      this.setState({ touchEnd: e.clientX });
    }
  };

  handleTouchEnd = (idx) => {
    this.setState({ mouseDown: false });
    const preventAction = idx === 0 || (this.props.items.length % 2 === 0 && idx === this.props.items.length/2);
    if (preventAction) return;
    const { touchStart, touchEnd } = this.state;
    // console.log(touchStart, touchEnd);
    const sensitiviy = 60;
    if (touchStart - touchEnd > sensitiviy) {
      // console.log('moveSliderRight');
      if (!this.state.panels[idx].open) {
        this.handleClick(idx);
        this.props.onProdInteraction(this.props.items[idx*2]);
        this.fireImpressionTrackers([idx*2, idx*2 + 1]);
      }
    }

    if (touchStart - touchEnd < -sensitiviy) {
      // console.log('moveSliderLeft');
      if (this.state.panels[idx].open) {
        this.handleClick(idx);
        this.props.onProdInteraction(this.props.items[idx*2 - 1]);
        // console.log('Prod >>>>',idx*2 - 1)
        this.fireImpressionTrackers([idx*2 - 1, idx*2 - 2]);
      }
    }
  };
/**
 * 
 * @param {array of product index to fire tracker} productIndex 
 */
  fireImpressionTrackers = (productIndex) => {
    const { items } = this.props;
    let prodTrackers = items.filter((item, idx) => productIndex.includes(idx)).map(prod => prod.details.impTracker);
    // console.log({trackers});
    let trackers = [];
    prodTrackers.forEach((trackerStr="") => {
      trackers = trackerStr ? [...trackers, ...trackerStr.split('||')] : trackers;
    });
    trackers.forEach(tracker => {
      if (tracker) {
        addPixelImage(tracker);
      }
    });
  }

  render(props, state) {
    const numPanels = state.panels.length;
    return (
      <div class={style.container}>
        <div class={style.flipPanel}>
          {state.panels.map((p, idx) => {
            const zIdx = numPanels - idx;
            return (
              <div
                class={`${style.panel} ${p.open ? style.open : ''}`}
                style={{ zIndex: p.adjust ? 1 : zIdx }}
                data={idx}
              >
                <div
                  // onClick={() => this.handleClick(idx)}
                  onTouchStart={this.handleTouchStart}
                  onTouchMove={this.handleTouchMove}
                  onTouchEnd={() => this.handleTouchEnd(idx)}
                  onMouseDown={this.handleMouseDown}
                  onMouseMove={this.handleMouseMove}
                  onMouseUp={() => this.handleTouchEnd(idx)}
                >
                  <div class={style.front}>
                    <Slide item={p.front} onItemClick={props.onProdCtaClick} />
                  </div>

                  <div class={style.back}>
                    {p.back && <Slide item={p.back} onItemClick={props.onProdCtaClick} />}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

MagazineGallery.defaultProps = {
  panels: [],
};



// WEBPACK FOOTER //
// ./components/spareparts/magazineGallery/index.js